export const ADD_MEMBER = 'ADD_MEMBER';
export const LOAD_MEMBER = 'LOAD_MEMBER';
export const LOAD_MEMBER_FOR_CONGRESS = 'LOAD_MEMBER_FOR_CONGRESS';
export const LOAD_MEMBER_LIST = 'LOAD_MEMBER_LIST';
export const LOAD_PARTY_VOTE_STATS = 'LOAD_PARTY_VOTE_STATS'
export const RENDER_MEMBER = 'RENDER_MEMBER';
export const RENDER_LOADED_MEMBER = 'RENDER_LOADED_MEMBER';
export const RENDER_MEMBER_LIST = 'RENDER_MEMBER_LIST';
export const UPDATE_MEMBER_STORIES = 'UPDATE_MEMBER_STORIES';
export const UPDATE_MEMBER_VOTE_STATS = 'UPDATE_MEMBER_VOTE_STATS';
export const UPDATE_PARTY_VOTE_STATS = 'UPDATE_PARTY_VOTE_STATS';

export function addMember(member) {
  return {
    type: ADD_MEMBER,
    member: member
  };
}

export function loadMemberList(congressId) {
  return {
    type: LOAD_MEMBER_LIST,
    congressId: congressId
  };
}

export function loadMember(personId) {
  return {
    type: LOAD_MEMBER,
    personId: personId
  };
}

export function loadMemberForCongress(personId, congressId) {
  return {
    type: LOAD_MEMBER_FOR_CONGRESS,
    personId: personId,
    congressId: congressId
  };
}

export function updateMemberVoteStats(personId, memberStats) {
  return {
    type: UPDATE_MEMBER_VOTE_STATS,
    personId: personId,
    memberStats: memberStats
  };
}

export function loadPartyVoteStats() {
  return {
    type: LOAD_PARTY_VOTE_STATS
  };
}

export function updatePartyVoteStats(partyStats) {
  return {
    type: UPDATE_PARTY_VOTE_STATS,
    partyStats: partyStats
  };
}

export function renderMember(member) {
  return {
    type: RENDER_MEMBER,
    member: member
  };
}

export function renderLoadedMember(personId) {
  return {
    type: RENDER_LOADED_MEMBER,
    personId: personId
  };
}

export function renderMemberList(memberList) {
  return {
    type: RENDER_MEMBER_LIST,
    memberList: memberList
  };
}

export function updateMemberStories(personId, recentStories) {
  return {
    type: UPDATE_MEMBER_STORIES,
    personId: personId,
    recentStories: recentStories
  };
}